import { useEffect, useState } from "react";

const isBrowser = () =>
  typeof window !== "undefined" && typeof window.localStorage !== "undefined";

export function useLocalStorage(key, initialValue) {
  const read = () => {
    if (!isBrowser()) return initialValue;
    try {
      const raw = window.localStorage.getItem(key);
      return raw === null ? initialValue : JSON.parse(raw);
    } catch {
      return initialValue;
    }
  };

  const [value, setValue] = useState(read);

  // Persist on change
  useEffect(() => {
    if (!isBrowser()) return;
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // ignore quota/private mode errors
    }
  }, [key, value]);

  // Sync across tabs
  useEffect(() => {
    if (!isBrowser()) return;
    const onStorage = (e) => {
      if (e.key === key) {
        try {
          setValue(e.newValue === null ? initialValue : JSON.parse(e.newValue));
        } catch {
          setValue(initialValue);
        }
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [key, initialValue]);

  return [value, setValue];
}
